import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import {
  useESGDataEntryStore,
  useESGDisclosureSelectionStore,
} from "@/features/esg/hooks/useESGReportStore";
import { useTran } from "@/hooks";
import { ChevronRight } from "lucide-react";
import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import { Fragment } from "react";

const DataEntryHeader = observer(() => {
  const { t } = useTran();
  const {
    progressPercentage,
    activeCategory,
    setActiveCategory,
    completedCountByCategory,
  } = useESGDataEntryStore();
  const { selectedCount, selectedCodesByCategory } =
    useESGDisclosureSelectionStore();

  const categoryGroups = Object.keys(selectedCodesByCategory)
    .map((category) => ({
      category,
      selectedCount: selectedCodesByCategory[category].length,
    }))
    .filter(({ selectedCount }) => selectedCount > 0);

  useEffect(() => {
    if (!activeCategory && categoryGroups.length > 0) {
      setActiveCategory(categoryGroups[0]?.category);
    }
  }, [activeCategory, setActiveCategory, selectedCodesByCategory]);

  return (
    <>
      <div className="flex gap-x-2 items-center justify-between">
        <div className="flex gap-x-2 items-center">
          <p className="text-muted-foreground text-sm">
            {t("Fill in data for each category")}
          </p>
          <Badge variant="primary">
            {t(`Overall ${progressPercentage}% Completed`)}
          </Badge>
        </div>
        <Badge variant="primary">{t(`${selectedCount} selected`)}</Badge>
      </div>

      {/* Category tabs */}
      <div className={`flex flex-wrap items-center gap-3`}>
        {categoryGroups.map((group, index) => {
          const showChevron = index !== categoryGroups.length - 1;
          const { category, selectedCount } = group;
          const isActive = category === activeCategory;

          return (
            <Fragment key={category}>
              <Button
                variant={isActive ? "default" : "outline"}
                className={`flex-1 flex items-center justify-between gap-2 rounded-full px-3 py-1 font-semibold`}
                key={category}
                onClick={() => setActiveCategory(category)}
              >
                <span>{t(category)}</span>
                <span className={`text-xs`}>
                  {completedCountByCategory(category)}/{selectedCount} filled
                </span>
              </Button>
              {showChevron && (
                <ChevronRight className="h-5 w-5 shrink-0 text-slate-400" />
              )}
            </Fragment>
          );
        })}
      </div>
    </>
  );
});

export default DataEntryHeader;
